import withLoader from "../withLoader.js";
import profile from "../assets/profile.png";
const About = () => {
  return (
    <div className="about-page">
      <img
        alt="about-image"
        className="about-image"
        // src="https://firebasestorage.googleapis.com/v0/b/wb-blog-a5b1d.appspot.com/o/about%2F600x840.png?alt=media&token=929e1c87-bc7f-485d-a926-3df658779f1a"
        src={profile}
      />
      <h1 className="about-header">About</h1>
      <p className="about-detailes">
        Hi, I’m Demetrious Mizzawi — a civil engineer living in the Netherlands,
        originally from Damascus, Syria. I’ve always had a deep fascination with
        how things are built — not only bridges and buildings, but also moments,
        emotions, and memories. I spent part of my life in Prague, where I fell
        in love with Western culture, art, and architecture. The city’s rhythm
        and elegance inspired me to pick up a camera, and that’s where my
        journey into photography truly began. Engineering is my profession, but
        photography is my language. Through my lens, I try to capture the
        harmony between structure and soul — the balance between precision and
        emotion. For me, photography isn’t just about taking pictures; it’s
        about seeing differently — noticing light, shadow, and detail in ways
        that remind me how beautiful the world can be when we slow down to look.
        It started as a hobby, and it still is — one that keeps me curious,
        grounded, and inspired.
      </p>
    </div>
  );
};

export default withLoader(About);
